module.exports = __webpack_public_path__ + "img/download-icon-white.cf7589bd.svg";